<div class="w-full max-w-2xl rounded-2xl bg-white p-5 shadow-xl">
  <div class="flex items-start justify-between gap-4">
    <div>
      <h2 class="text-lg font-semibold text-slate-950">Switch workspace</h2>
      <p class="mt-1 text-sm text-slate-500">Choose a workspace to open.</p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  @if (workspacesState.loading()) {
    <p class="mt-6 text-sm text-slate-500">Loading workspaces…</p>
  } @else if (workspacesState.failed()) {
    <p class="mt-6 text-sm text-red-600">Could not load workspaces.</p>
  } @else {
    <div class="mt-5 max-h-80 space-y-5 overflow-auto">
      @for (group of workspaceGroups(); track group.companyId) {
        <div class="space-y-2">
          <p class="px-1 text-xs font-medium uppercase tracking-wide text-slate-500">
            {{ group.companyName }}
          </p>
          @for (workspace of group.workspaces; track workspace.id) {
            <button
              type="button"
              class="w-full cursor-pointer rounded-xl border border-slate-200 bg-transparent px-4 py-3 text-left transition hover:border-slate-300 disabled:cursor-not-allowed disabled:opacity-60"
              [class.border-slate-400]="workspace.id === currentWorkspaceId()"
              [disabled]="switchingWorkspaceId() !== null"
              (click)="onWorkspaceSelected(workspace)">
              <app-workspace-card [workspace]="workspace" />
            </button>
          }
        </div>
      }
    </div>

    <div class="mt-4 border-t border-slate-200 pt-4">
      <lib-signal-button
        appearance="outline"
        iconSrc="assets/icons/plus.svg"
        [fullWidth]="true"
        [disabled]="switchingWorkspaceId() !== null"
        (clicked)="onCreateWorkspace()">
        Create new workspace
      </lib-signal-button>
    </div>
  }
</div>
